import { useEffect, useState } from "react";

export const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(true);

    const checkInternet = async () => {
      
    try {
      // lightweight ping
    const res = await fetch("https://jsonplaceholder.typicode.com/posts/1", {
      method: "GET",
      cache: "no-store",
    });
        setIsOnline(true);
      //  console.log("TURE----- ",res);
    } catch {
        setIsOnline(false);
        console.log("FALSE---- ");
    }
  };

  useEffect(() => {
    const handleOnline = () => checkInternet();
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // 🔥 initial check
    checkInternet();

    // 🔥 interval check (important)
    const interval = setInterval(checkInternet, 5000);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      clearInterval(interval);
    };
  }, []);

  return isOnline;
};